/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * 
 * @export
 * @interface ShowDocumentResponse
 */
export interface ShowDocumentResponse {
    /**
     * 
     * @type {Document}
     * @memberof ShowDocumentResponse
     */
    data: Document;
}

/**
 * Check if a given object implements the ShowDocumentResponse interface.
 */
export function instanceOfShowDocumentResponse(value: object): value is ShowDocumentResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowDocumentResponseFromJSON(json: any): ShowDocumentResponse {
    return ShowDocumentResponseFromJSONTyped(json, false);
}

export function ShowDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': DocumentFromJSON(json['data']),
    };
}

  export function ShowDocumentResponseToJSON(json: any): ShowDocumentResponse {
      return ShowDocumentResponseToJSONTyped(json, false);
  }

  export function ShowDocumentResponseToJSONTyped(value?: ShowDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DocumentToJSON(value['data']),
    };
}

